import { assert, Test } from "oc-e2e-testrunner";
import { createMauer, resetArrangement } from "./utils";
import { v3 } from "oc-threejs/short3";

export default {
  name: "TestUMProfile",
};

export const testUMProfilAnMauer: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  const breite = 3;
  agt.grundriss.setStandardForm("Strecke", [breite]);
  createMauer({ position: v3(-breite / 2, 0, 0), size: v3(1, 2, 0.2) });
  agt.fillIndividuellSegmentsWithElements();
  const s = agt.segmente[0];
  assert.isTrue(s.getPartsAndPfosten()[0].isUMProfil);
};

export const testUMProfilTorpfostenSteckpfosten: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  agt.grundriss.setStandardForm("Strecke", [3]);
  agt.pfostenartAuswahlwert = APP.richMetadata.findAuswahlwert("Steckpfosten");
  agt.fillIndividuellSegmentsWithElements();
  const s = agt.segmente[0];
  const element = s.getElemente()[0];
  const massAuswahlwert = APP.richMetadata.findAuswahlwert("Einzeltor_Easy");
  element.change({
    massAuswahlwert,
  });
  agt.update3d();
  // krass! hier braucht man ein zweites update3d...
  agt.update3d();
  const umprofil = s.getPartsAndPfosten()[s.getPartsAndPfosten().findIndex((x) => x.isTor) + 2];
  assert.isTrue(umprofil.isUMProfil);
  assert.isTrue(umprofil.meta.Typ == "U-Montageprofil");
};

export const testUMProfilTorpfostenSteckpfostenAn14cmElement: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  agt.grundriss.setStandardForm("Strecke", [3]);
  agt.pfostenartAuswahlwert = APP.richMetadata.findAuswahlwert("Steckpfosten");
  agt.fillIndividuellSegmentsWithElements();
  const s = agt.segmente[0];
  const element = s.getElemente()[0];
  const massAuswahlwert = APP.richMetadata.findAuswahlwert("Einzeltor_Easy");
  element.change({
    massAuswahlwert,
  });
  const zaunelement = s.getElemente()[1];
  zaunelement.setKonfigurierbareBreite(0.14);
  agt.update3d();
  // krass! hier braucht man ein zweites update3d...
  agt.update3d();
  const umprofil = s.getPartsAndPfosten()[s.getPartsAndPfosten().findIndex((x) => x.isTor) + 2];
  assert.isTrue(umprofil.isUMProfil);
  assert.isTrue(umprofil.meta.Typ == "U-Montageprofil");
};

export const testUMProfilTorpfostenKlemmpfosten: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  agt.grundriss.setStandardForm("Strecke", [3]);
  agt.pfostenartAuswahlwert = APP.richMetadata.findAuswahlwert("Klemmpfosten");
  agt.fillIndividuellSegmentsWithElements();
  const s = agt.segmente[0];
  const element = s.getElemente()[0];
  const massAuswahlwert = APP.richMetadata.findAuswahlwert("Einzeltor_Easy");
  element.change({
    massAuswahlwert,
  });
  agt.update3d();
  // krass! hier braucht man ein zweites update3d...
  agt.update3d();
  const umprofil = s.getPartsAndPfosten()[s.getPartsAndPfosten().findIndex((x) => x.isTor) + 2];
  assert.isTrue(umprofil.isUMProfil);
  assert.isTrue(umprofil.meta.Typ == "U-Klemmprofil");
};

export const testUMProfilTorpfostenKlemmpfostenAn14cmElement: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  agt.grundriss.setStandardForm("Strecke", [3]);
  agt.pfostenartAuswahlwert = APP.richMetadata.findAuswahlwert("Klemmpfosten");
  agt.fillIndividuellSegmentsWithElements();
  const s = agt.segmente[0];
  const element = s.getElemente()[0];
  const massAuswahlwert = APP.richMetadata.findAuswahlwert("Einzeltor_Easy");
  element.change({
    massAuswahlwert,
  });
  const zaunelement = s.getElemente()[1];
  zaunelement.setKonfigurierbareBreite(0.14);
  agt.update3d();
  // krass! hier braucht man ein zweites update3d...
  agt.update3d();
  const umprofil = s.getPartsAndPfosten()[s.getPartsAndPfosten().findIndex((x) => x.isTor) + 2];
  assert.isTrue(umprofil.isUMProfil);
  assert.isTrue(umprofil.meta.Typ == "U-Klemmprofil");
};

export const testZweiUMProfile14cmElementZwischenToren: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  agt.grundriss.setStandardForm("Strecke", [5]);
  agt.pfostenartAuswahlwert = APP.richMetadata.findAuswahlwert("Steckpfosten");
  agt.fillIndividuellSegmentsWithElements();
  const s = agt.segmente[0];
  const massAuswahlwert = APP.richMetadata.findAuswahlwert("Einzeltor_Easy");
  [s.getElemente()[0], s.getElemente()[2]].forEach((e) =>
    e.change({
      massAuswahlwert,
    })
  );
  const zaunelement = s.getElemente()[1];
  zaunelement.setKonfigurierbareBreite(0.14);
  agt.update3d();
  // krass! hier braucht man ein zweites update3d...
  agt.update3d();
  const umprofile = [
    s.getPartsAndPfosten()[s.getPartsAndPfosten().findIndex((x) => x.isTor) + 2],
    s.getPartsAndPfosten()[s.getPartsAndPfosten().findLastIndex((x) => x.isTor) - 2],
  ];
  assert.isTrue(umprofile.every((u) => u.isUMProfil));
  assert.isTrue(umprofile.every((u) => u.meta.Typ == "U-Montageprofil"));
};

export const testUMProfilGlaselement: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  agt.grundriss.setStandardForm("Strecke", [3]);
  agt.fillIndividuellSegmentsWithElements();
  const s = agt.segmente[0];
  const element = s.getElemente()[0];
  const füllungAuswahlwert = APP.richMetadata.findAuswahlwert("SYSTEM GLAS Beta");
  element.change({
    füllungAuswahlwert,
  });
  agt.update3d();
  assert.isFalse(
    s.getPartsAndPfosten()[s.getPartsAndPfosten().findIndex((x) => x.isTor) + 2].isUMProfil
  );
};

export const testKeinUMProfilBeiNormalenElementen: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  agt.grundriss.setStandardForm("Strecke", [3]);
  agt.fillIndividuellSegmentsWithElements();
  const s = agt.segmente[0];
  assert.isTrue(s.getPartsAndPfosten().every((p) => !p.isUMProfil));
};
